var path = 'app/reporting/campaigns/list.html';
var html = "<div ng-include=\"'app/reporting/lists/reportsList.html'\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;